import React from "react";
import { usePageTitle } from "../lib/usePageTitle";
import { SITE_LOGO, SITE_NAME } from "../lib/seo";

export const PageLoader = ({ name }) => {
  usePageTitle(name ? `Loading ${name}…` : `Loading ${SITE_NAME}…`);

  return (
    <div className="page-loader" role="status" aria-live="polite">
      <img
        className="page-loader__logo"
        src={SITE_LOGO}
        alt={SITE_NAME}
        width="180"
        height="180"
      />
      <p>{name ? `Loading ${name}…` : "Loading…"}</p>
    </div>
  );
};
